/**
 * @template T
 * @param {boolean} condition
 * @param  {...T} elements
 * @returns {Array<T>}
 */
export const insertIf = (condition, ...elements) => (condition ? elements : []);
